/**
 * The pharmacist's new-order popup (Rx-01): a small card in its own top-right toaster (main.tsx),
 * so it never covers the page's work. View opens the order page, where the usual flow (claim →
 * confirm address → price) takes over; Ignore just closes it. Shown by
 * components/PushNotifications.tsx, which hides it after 5 s without a reply.
 */

import type { OrderSummary } from "../api/orders";

export const NEW_ORDER_TOASTER = "new-orders";

export function NewOrderCard({
  order,
  onView,
  onIgnore,
}: {
  order: OrderSummary;
  onView: () => void;
  onIgnore: () => void;
}) {
  const time = new Date(order.created_at).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  return (
    <div role="status" aria-live="polite" className="w-[340px] max-w-[calc(100vw-32px)] rounded-xl border border-gray-200 bg-white p-4 shadow-lg">
      <div className="flex items-center gap-2">
        <span className="h-2 w-2 shrink-0 rounded-full bg-brand" aria-hidden />
        <p className="text-sm font-semibold text-gray-900">New order in the queue</p>
      </div>
      <p className="mt-1 font-mono text-sm text-gray-700">{order.order_id}</p>
      <p className="text-xs text-gray-500">
        {order.line_count} item{order.line_count === 1 ? "" : "s"} · placed {time}
      </p>
      <div className="mt-3 flex justify-end gap-2">
        <button onClick={onIgnore} className="rounded-lg border px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50">
          Ignore
        </button>
        <button onClick={onView} className="rounded-lg bg-brand px-3 py-1.5 text-sm font-medium text-brand-fg">
          View
        </button>
      </div>
    </div>
  );
}
